export const RolesEnum = {
    ADMINISTRATOR : 'Administrator',
    SPECIALIST_FEEDER: 'Specialist-Feeder',
    SPECIALIST_PRE_MANAGER: 'Specialist-Pre-Manager',
    SPECIALIST_MANAGER: 'Specialist-Manager',
    SPECIALIST_VALIDATOR: 'Specialist-Validator',
    SPECIALIST_VERIFICATOR: 'Specialist-Verificator',
    SPECIALIST_EDITOR: 'Specialist-Editor',
    SPECIALIST_COORDINATOR: 'Specialist-Coordinator',
    SPECIALIST_LIAISON: 'Specialist-Liaison',
    END_USER: 'End-User',
    END_USER_INSTITUTIONAL: 'End-User-Institutional',
    CLIENT: 'Client',
    GUEST: 'Guest',
    REGISTERED: 'Registered',
    REPORTER: 'Reporter'
  }
